export default {"src":"/_next/static/image/public/images/ic_trash_blue.5f37b5271f2da1e1a5949c41436c0156.svg","height":20,"width":18};